//
//
//
//
//
//

import { getUserInfo, isWeiXin, system, isApp, shareFun, callApp, gappparamsselect, ssologin } from '@/util/const'
import {getQueryVariable } from '@/util/const'
import { setAuthorization } from '../../axios/userInfo'

export default {
  components: {
  },
  data () {
    return {
      scode: 'ssss',
      ver:'',
      url:''
    }
  },
  created () {
    console.log('dddd', window.document.referrer)
    gappparamsselect({ jsmethodname: 'gappparamsselect', channelsign: 'B100093' })
    window.gappparamsselect = (obj) => {
      if (obj) {
        console.log('scode??',obj)
        let param  =JSON.parse(obj)
        if(param['scode']){
          console.log('getscode')
        this.scode = param['scode']
        }
        this.ver = param['ver']
        this.send()
      }
    }
  },
  mounted () {

  },
  methods: {
    send (){
      let param = {
        "scode":this.scode
      }
      this.$http.postsso(`/api/cmccbeijing/H5/v1/getBeiJingToken`,param ).then(res => {
       if(res.data.code === '0'){
         this.url = `http://cp.jegotrip.com.cn/partners/mallh5test/autologin/jtp.html?jtptoken=${res.data.body.jtpToken}`
         //this.url = 'http://cp.jegotrip.com.cn/partners/mallh5test/autologin/jtp.html?jtptoken=8c5ada902a39417683ed8241aa986ad5'
         window.location.href = this.url
       } else {
         console.log('验证失败')
         let url ='http://mylink.komect.com/activity/mylinkActivity/#/login'
         //url = encodeURIComponent(url)
         ssologin({ refreshurl: url, channelsign: 'B100093' })
       }
      })
    },
    jump(){
      window.location.href = this.url
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/birthday/login.vue